const translations = {
  "en": {
    "Invalid email address. Please try again.": "Invalid email address. Please try again.",
    "Invalid verification code. Please try again.": "Invalid verification code. Please try again.",
    "operation too many times. Please try again tomorrow.": "operation too many times. Please try again tomorrow.",
    "Verification code sent too frequently. Please try again later.": "Verification code sent too frequently. Please try again later."
  },
  "zh-tw": {
    "Invalid email address. Please try again.": "電子郵件地址無效。請再試一次。",
    "Invalid verification code. Please try again.": "驗證碼錯誤，請再試一次。",
    "operation too many times. Please try again tomorrow.": "操作次數過多。請明天再試一次。",
    "Verification code sent too frequently. Please try again later.": "驗證碼發送過於頻繁。請稍後再試。"
  }
};

export default translations;
